import {DESKTOP_HEADER_HEIGHT} from "../constants";

export default () => ({
    sidebarState: 'static',
    scrollEndState: false,
    sidebarOffset: 0,
    onScroll() {
        const scrollPosition = window.scrollY;
        if (window.innerHeight >= this.$root.offsetTop + this.$root.offsetHeight) {
            this.sidebarState = 'static'
        } else if (scrollPosition + window.innerHeight >= this.$root.offsetTop + this.$root.offsetHeight) {
            this.sidebarState = 'end';
        } else if (scrollPosition >= this.sidebarOffset - DESKTOP_HEADER_HEIGHT) {
            this.sidebarState = 'fixed';
        } else {
            this.sidebarState = 'static';
        }
    },
    init() {
        this.sidebarOffset = this.$refs.sidebar.offsetTop;
        window.addEventListener('scroll', this.onScroll.bind(this));
        window.addEventListener('resize', this.onScroll.bind(this));
        this.onScroll();
    }
});